interface ModalProps {
    children: React.ReactNode;
    title: string;
    onClose: () => void;
}

export function Modal({ children, title, onClose }: ModalProps) {
    return (
        <div
            onClick={onClose}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
        >
            <div
                onClick={e => e.stopPropagation()}
                className="w-full max-w-lg rounded-xl bg-surface-700 border border-border p-6 shadow-xl"
            >
                <h3 className="mb-4 text-h4 text-text-primary">{title}</h3>
                {children}
            </div>
        </div>
    );
}
